import { Car, Sofa, Laptop, Shirt, Bike, Gamepad2, Wrench, Baby, Package, Hourglass, BookOpen } from "lucide-react";

export const CATEGORIES = [
  { id: "cars", name: "Cars & Parts", icon: Car },
  { id: "home", name: "Home & Garden", icon: Sofa },
  { id: "electronics", name: "Electronics", icon: Laptop },
  { id: "fashion", name: "Fashion", icon: Shirt },
  { id: "sports", name: "Sports & Outdoors", icon: Bike },
  { id: "toys", name: "Toys & Hobbies", icon: Gamepad2 },
  { id: "tools", name: "Tools & DIY", icon: Wrench },
  { id: "baby", name: "Baby & Kids", icon: Baby },
  { id: "antiques", name: "Antiques", icon: Hourglass },
  { id: "ebooks", name: "Books & eBooks", icon: BookOpen },
  { id: "other", name: "Other", icon: Package },
];

export const ERAS = [
  { id: "pre-1800", name: "Pre-1800" },
  { id: "1800s", name: "1800s" },
  { id: "1900-1945", name: "Early 1900s (1900–1945)" },
  { id: "1945-1970", name: "Mid-century (1945–1970)" },
  { id: "1970-1999", name: "Late 1900s (1970–1999)" },
  { id: "unknown", name: "Not sure" },
];

export const eraName = (id) => ERAS.find((e) => e.id === id)?.name || id;

export const catName = (id) => CATEGORIES.find((c) => c.id === id)?.name || id;

export const STATES = [
  { id: "QLD", name: "Queensland" },
  { id: "NSW", name: "New South Wales" },
  { id: "VIC", name: "Victoria" },
  { id: "SA", name: "South Australia" },
  { id: "WA", name: "Western Australia" },
  { id: "TAS", name: "Tasmania" },
  { id: "NT", name: "Northern Territory" },
  { id: "ACT", name: "ACT" },
];

export const CONDITIONS = [
  { id: "new", name: "Brand new" },
  { id: "like_new", name: "Like new" },
  { id: "good", name: "Good" },
  { id: "fair", name: "Fair" },
  { id: "for_parts", name: "For parts" },
];

export const condName = (id) => CONDITIONS.find((c) => c.id === id)?.name || id;

export const SAFETY_TIPS = [
  "Meet in a public, well-lit place during daylight.",
  "Inspect the item fully before you pay.",
  "Pay cash or instant bank transfer (PayID/Osko) only at pick-up.",
  "Never pay a deposit or send money before seeing the item.",
  "Bring a friend and tell someone where you're going.",
];
